import { SVGProps } from 'react';

export const UploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="91"
    height="90"
    viewBox="0 0 91 90"
    fill="none"
    {...props}
  >
    <circle cx="45.5" cy="45" r="45" fill="currentColor" fillOpacity="0.1" />
    <circle
      cx="45.4997"
      cy="45"
      r="38.7692"
      fill="currentColor"
      fillOpacity="0.15"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.3458 36.6922V28.6153L58.4228 36.6922H50.3458ZM47.1159 48.0001V56.077H43.8851V48.0001H39.0389L45.5005 41.5385L51.962 48.0001H47.1159ZM52.6307 27H34.1927C32.4109 27 30.9619 28.4506 30.9619 30.2308V59.3077C30.9619 61.0895 32.4109 62.5385 34.1927 62.5385H56.8081C58.5898 62.5385 60.0388 61.0895 60.0388 59.3077V34.4082L52.6307 27Z"
      fill="currentColor"
    />
  </svg>
);
